import React from 'react';

type SmallAvatarGroupProps = {
    imageUrls: string[];
    showNumberAvatars?: number;
};

const SmallAvatar: React.FC<{ imageUrl: string }> = ({ imageUrl }) => (
    <div className={`inline-block rounded-full overflow-hidden border-2 border-white`}>
        <img src={imageUrl} alt="Avatar" className="w-10 h-10 object-cover" />
    </div>
);

const SmallAvatarGroup: React.FC<SmallAvatarGroupProps> = ({ imageUrls, showNumberAvatars = 3 }) => {
    const numberOfAvatarsToShow = Math.min(showNumberAvatars, imageUrls.length);

    return (
        <div className="flex items-center">
            {imageUrls.slice(0, numberOfAvatarsToShow).map((url, index) => (
                <div key={index} className={index === 0 ? '' : `-ml-3`}>
                    <SmallAvatar imageUrl={url} />
                </div>
            ))}
            {imageUrls.length > numberOfAvatarsToShow && (
                <div className={`flex rounded-full overflow-hidden bg-gradient-to-r bg-background1 text-text1 dark:bg-dark-background1 dark:text-dark-text1 border-2 -ml-5 w-10 h-10 items-center justify-center shadow-lg`}>
                    +{imageUrls.length - numberOfAvatarsToShow}
                </div>
            )}
        </div>
    );
};

export default SmallAvatarGroup;